import { ListItemKPI } from 'types';

const TopHeader = ({
  title,
  subTitle,
  listItem,
  className,
}: {
  title: string;
  subTitle: string;
  listItem?: ListItemKPI[];
  className?: string;
}) => {
  return (
    <div
      className={
        'px-[24px] py-[12px] bg-[var(--textWhite)] border-b border-[var(--textBlack8)] sticky z-10 ' + className
      }
    >
      <div className='flex flex-wrap justify-between items-center gap-[18px] 2xl:gap-6'>
        <div className='flex flex-col gap-[8px]'>
          <p className='text-[20px] font-bold text-[var(--textBlack100)]'>{title}</p>
          <p className='text-[14px] text-[var(--textBlack56)]'>{subTitle}</p>
        </div>
        <div className='flex items-center'>
          {(listItem || [])?.map((item, index) => (
            <div
              key={index}
              className={
                ' flex items-center flex-col gap-[4px] px-[32px] cursor-pointer' +
                (index > 0 ? ' border-l border-[var(--textBlack56)] ' : '')
              }
              onClick={item.onClick}
            >
              <div className='flex gap-[12px] items-center h-[40px]'>
                <div className='w-[32px] h-[32px] flex items-center justify-center'>{item.icon}</div>
                <p className='text-[36px] font-bold text-[var(--textBlack)]'>{item.value}</p>
              </div>
              <div className='flex gap-[8px] items-center'>
                {item.iconDescription && <p className='w-[10px] h-[10px] '>{item.iconDescription}</p>}
                <div
                  className='text-[14px] text-[var(--textBlack56)] leading-[20px]'
                  dangerouslySetInnerHTML={{ __html: item.description as string }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
